export default __webpack_public_path__ + "static/media/Design_Track.4183736f.svg";